import { Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import { useNumbers } from 'ui/components/utils/useNumbers'
import { Percentual } from '../../../../../typings'
import { ReviewProps } from './constants'
import { messages } from './messages'

export function PercentualPriceRecap(props: ReviewProps) {
  const { config } = props
  const { formatPercentual } = useNumbers()

  if (!config.benefit || !config.scope) return null

  const { benefit, scope } = config

  return (
    <FormattedMessage
      {...messages.percentualPrice}
      values={{
        b: (content) => <Text variant="action1">{content}</Text>,
        discount: formatPercentual((benefit as Percentual).value),
        applyTo: scope.applyTo,
      }}
    />
  )
}
